var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BlocInfoPointDeVente'),_c('CartoGeneral',{staticClass:"mt-20"}),_c('ListesPanneau',{staticClass:"mt-20"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }